export const structuredDataSources = [
  {
    title: 'Project Status',
    content:
      'Includes information on Project Health Statuses, Issues Log, Change Register, Punch list, High Risk activities, Quality Assurance Plan, CCRPs, NPS, NCRs, Physical Progress. ',
    sourceSystem: 'PPRT, Primavera P6, CCRP, Salesforce, Unifier, NCR Register.​',
    prompts: [
      'What is the health status of projects in Europe?',
      'What are the critical issues of Sweden’s projects?',
      'How many open CCRPs are in North America projects?'
    ],
    datasourcelink: ''
  },
  {
    title: 'Project Planning',
    content:
      'Includes information on OTD Milestones, Critical Path activities, Resource Plan, On-Time Performance activities and Stage Gate Milestones.',
    sourceSystem: 'Primavera P6 ​',
    prompts: [
      'How many OTD Milestones are forecasted in next 3 months?',
      'What is On-Time Performance of projects in Germany?',
      'What are critical path activities in project 2226XYZ1234567?'
    ],
    datasourcelink: ''
  },
  {
    title: 'Project Setup',
    content: 'Includes information on Contract Wallchart, Country and Security rating and Division of Work.',
    sourceSystem: 'PPRT ​',
    prompts: [
      'What are notification requirements in project 2226XYZ1234567?',
      'What is the scope of project 2226XYZ1234567',
      'What is the international SOS Risk rating for project 2226XYZ1234567?'
    ],
    datasourcelink: ''
  },
  {
    title: 'Finance Reporting',
    content:
      'Includes information on Risks, Contingencies, Opportunities, Revenue, Full Cost Model, Cash Flow and Time-Phased Cost.',
    sourceSystem: 'REIWA, Unifier​',
    prompts: [
      'What are the top 5 Risks in my portfolio?',
      'Any Lesson Learnt for packaging materials?',
      'What are the projects with highest total revenue?'
    ],
    datasourcelink: ''
  },
  {
    title: 'Organizations',
    content: 'Includes information about project team members.',
    sourceSystem: 'PPRT ​',
    prompts: [
      'Who is project manager in project 2226XYZ1234567?',
      'Who is project planner in project 2226XYZ1234567?',
      'Which project manager has the most projects in Europe?'
    ],
    datasourcelink: ''
  },
  {
    title: 'Minutes of the meeting',
    content: 'Includes information about actions and decisions taken during the project review meeting.',
    sourceSystem: 'PPRT ​',
    prompts: [
      'What are the decisions taken during the last review for project 2226XYZ1234567?',
      'What is the deadline for next action in project 2226XYZ1234567?'
    ],
    datasourcelink: ''
  }
]
